<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Comprobantes de Pago"
          directory="Verificación de comprobantes de pago"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>

    <form
      ref="form"
      :data-url="`/treasury/deposits/${depositId}`"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div v-if="inputs.i_business_name">
        <div class="row" v-if="!inputs.is_agreement">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>DATOS PARA FACTURACIÓN</h5>
          </legend>

          <div class="col-md-6">
            <div class="form-group">
              <label>Razón Social</label>
              <app-input
                type="text"
                v-model="inputs.i_business_name"
                :disabled="disabled"
                placeholder="Ingrese el Razón social"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>RUC</label>
              <app-input
                type="text"
                v-model="inputs.i_taxid"
                :disabled="disabled"
                placeholder="Ingrese el RUC"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>País</label>
              <app-input
                type="select"
                v-model="inputs.i_country_id"
                :list="countryList"
                :disabled="disabled"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="inputs.i_country_id && !inputs.i_province_id"
          >
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="text"
                v-model="inputs.i_city"
                placeholder="Ingrese la ciudad"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.i_province_id">
            <div class="form-group">
              <label>Provincia</label>
              <app-input
                type="select"
                v-model="inputs.i_province_id"
                :list="provinceList"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.i_province_id">
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="select"
                v-model="inputs.i_canton_id"
                :list="cantonList"
                :disabled="disabled"
                placeholder="Ingrese la ciudad"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.i_email"
                placeholder="Ingrese su email"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.i_phone"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Dirección</label>
              <app-input
                type="textarea"
                v-model="inputs.i_address"
                :disabled="disabled"
                placeholder="Ingrese la dirección"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="inputs.delegate_name">
        <div class="row">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>DATOS PERSONA RESPONSABLE DE LA ACREDITACIÓN (CONTACTO)</h5>
          </legend>

          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre</label>
              <app-input
                type="text"
                v-model="inputs.delegate_name"
                :disabled="disabled"
                placeholder="Ingrese el nombre"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Cargo</label>
              <app-input
                type="text"
                v-model="inputs.delegate_position"
                :disabled="disabled"
                placeholder="Ingrese el RUC"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.delegate_email"
                placeholder="Ingrese su email"
                :disabled="disabled"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.delegate_phone"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Celular</label>
              <app-input
                type="tel-input"
                v-model="inputs.delegate_cell"
                :disabled="disabled"
                placeholder="Ingrese el teléfono"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="inputs.is_agreement">
        <div class="col-6">
          <div class="form-group text-center">
            <p class="card-title m-0" v-if="!inputs.is_agreement">
              <strong>Comprobante de Pago</strong>
            </p>
            <p class="card-title m-0" v-if="inputs.is_agreement">
              <strong>Convenio</strong>
            </p>
            <br />
            <a
              :href="inputs.deposit_attach"
              class="btn btn-success"
              target="_blank"
            >
              <app-icon name="file" />
            </a>
          </div>
        </div>

        <div class="col-6" v-if="inputs.proforma">
          <div class="form-group text-center">
            <p class="card-title m-0">
              <strong>Proforma de servicios</strong>
            </p>
            <br />
            <a :href="inputs.proforma" class="btn btn-success" target="_blank">
              <app-icon name="file" />
            </a>
          </div>
        </div>
      </div> -->

      <div>
        <div class="row">
          <legend
            class="col-12 col-form-label text-primary pt-0 my-3"
            v-if="!inputs.is_agreement"
          >
            <h5>{{ titlePayment }}</h5>
          </legend>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Beneficiario</label>
              <app-input
                id="inputs_beneficiary"
                type="text"
                disabled
                v-model="inputs.beneficiary"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>OEC</label>
              <app-input
                id="inputs_oec"
                type="text"
                disabled
                v-model="inputs.oec"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>CI/RUC</label>
              <app-input
                id="inputs_taxid"
                type="text"
                disabled
                v-model="inputs.taxid"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Banco</label>
              <app-input
                id="inputs_bank"
                type="text"
                disabled
                v-model="inputs.bank"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Tipo de Transacción</label>
              <app-input
                id="inputs_trasaction"
                type="text"
                disabled
                v-model="inputs.transactiontype"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Número de Transacción</label>
              <app-input
                id="inputs_number"
                type="text"
                :disabled="hide"
                v-model="inputs.number"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Valor</label>
              <app-input
                id="inputs_amount"
                type="text"
                disabled
                v-model="inputs.amount"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="!inputs.is_agreement">
            <div class="form-group">
              <label>Fecha</label>
              <app-input
                id="inputs_date"
                type="date"
                :disabled="hide"
                v-model="inputs.date"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <legend>
              <p class="text-primary">Documentos adjuntos</p>
            </legend>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody v-if="!inputs.eval_test">
                <tr v-if="inputs.request_file">
                  <td class="align-middle">Solicitud de Acreditación</td>
                  <td class="align-middle">
                    {{ inputs.request_file.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.request_file.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.deposit_attach">
                  <td class="align-middle">
                    <p class="card-title m-0" v-if="!inputs.is_agreement">
                      <strong>Comprobante de Pago</strong>
                    </p>
                    <p class="card-title m-0" v-if="inputs.is_agreement">
                      <strong>Convenio</strong>
                    </p>
                  </td>
                  <td class="align-middle">
                    {{ inputs.deposit_attach.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.deposit_attach.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="inputs.eval_test">
                <tr v-if="inputs.request_file">
                  <td class="align-middle">Solicitud de Acreditación</td>
                  <td class="align-middle">
                    {{ inputs.request_file.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.request_file.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.deposit_attach">
                  <td class="align-middle">
                    <p class="card-title m-0" v-if="!inputs.is_agreement">
                      <strong>Comprobante de Pago</strong>
                    </p>
                    <p class="card-title m-0" v-if="inputs.is_agreement">
                      <strong>Convenio</strong>
                    </p>
                  </td>
                  <td class="align-middle">
                    {{ inputs.deposit_attach.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.deposit_attach.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.eval_test.evaluation_team_file">
                  <td class="align-middle">Propuesta del Equipo Evaluador</td>
                  <td class="align-middle">
                    {{
                      inputs.eval_test.evaluation_team_file.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="
                        inputs && inputs.eval_test.evaluation_team_file
                          ? inputs.eval_test.evaluation_team_file.full_url
                          : ''
                      "
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
                <tr
                  v-for="(item, key) in inputs.eval_test.eval_annexes_files"
                  :key="key"
                >
                  <td class="align-middle">{{ item.filename }}</td>
                  <td class="align-middle">
                    {{ item.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="item.annexed.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

<!--                 <tr v-if="inputs.external_personal_payment_vouchers">
                  <td class="align-middle">
                    Comprobantes de pagos personal externo
                  </td>
                  <td class="align-middle">
                    {{
                      inputs.external_personal_payment_vouchers.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.external_personal_payment_vouchers.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>

                <tr v-if="inputs.external_personal_payment_invoices">
                  <td class="align-middle">
                    Facturas de pagos personal externo
                  </td>
                  <td class="align-middle">
                    {{
                      inputs.external_personal_payment_invoices.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="inputs.external_personal_payment_invoices.full_url"
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr> -->
              </tbody>
            </table>

            <br /><br />
            <legend v-if="inputs.proforma">
              <p class="text-primary">Proforma de servicios</p>
            </legend>
            <table
              class="table table-sm table-striped"
              v-if="inputs.proforma"
            >
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th>FECHA DE CREACIÓN</th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody v-if="inputs.eval_test">
                <tr>
                  <td class="align-middle">Proforma de Servicios</td>
                  <td class="align-middle">
                    {{ inputs.proforma.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      :href="
                        inputs && inputs.proforma
                          ? inputs.proforma.full_url
                          : ''
                      "
                      class="btn btn-success btn-md"
                      target="_blank"
                    >
                      <app-icon name="file"></app-icon> Ver
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-md-12" v-if="!hide">
            <br />
            <app-badge
              v-if="!inputs.is_approved"
              label="RECHAZADA"
              className="badge badge-danger badge-lg"
              class="col-sm-12"
            />
            <app-badge
              v-if="inputs.is_approved"
              label="APROBADA"
              className="badge badge-success badge-lg"
              class="col-sm-12"
            />
          </div>
        </div>
      </div>
    </form>

    <div class="row" v-if="cardPayment && cardPayment.id"> 
                <div class="col-sm-12 mt-2">
                  <legend>
                    <p class="text-uppercase h5 p-2 rounded" style="background-color: #eab308;" >
                      Datos para el pago de servicios con tarjeta
                    </p>
                  </legend>
                </div>
                <div class="col-md-6">
                  <div class="h6">
                    Nº de transacción
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      {{ cardPayment.transaction_reference}}
                  </p>
                </div>
                <div class="col-md-6">
                  <div class="h6">
                    Nombre de banco
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      {{ cardPayment.bank_name }}
                  </p>  
                </div>
                <div class="col-md-6">
                  <div class="h6">
                    Monto
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      ${{ cardPayment.amount }}
                  </p>
                </div>
                <div class="col-md-6">
                  <div class="h6">
                    Estado
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      {{ cardPayment.status_detail === 2 ? "Aprobado Parcialmente" :  "Aprobado" }}
                  </p>
                </div>

                <div class="col-md-6">
                  <div class="h6">
                    Producto
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      {{ cardPayment.product_description }}
                  </p>
                </div>
                <div class="col-md-6">
                  <div class="h6">
                    Fecha de transacción
                  </div>
                  <p class="bg-secondary text-white mt-2 p-2 rounded">
                      {{ formatDateLocal(cardPayment.payment_date)}}
                  </p>
                </div>
              </div>

    <div class="row">
      <div class="col-sm-12">
        <legend>
          <p class="text-primary">Adjuntar facturas</p>
        </legend>
      </div>
      <div class="col-sm-12">
        <div class="row mb-2" v-for="(vj, j) in files" :key="j">
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small class="text-center text-danger"
              >Tamaño máximo del archivo 8 Mb</small
            >
          </div>

          <div class="col-12 col-md-2" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>

          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>
        </div>
        <div class="row mt-2" v-if="!inputs.invoice_send">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
        <app-confirmation-modal
          v-if="deleteModal"
          modal-id="delete"
          @confirmed="confirmed"
          @cancelled="cancelled"
        />
      </div>
    </div>

    <br /><br />

    <div class="row" v-if="!inputs.invoice_send">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="openSendModal"
        >
          {{ $t("Envíar facturas") }}
        </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="sendInvoices"
      @cancelled="cancel"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import * as actions from "../../../apiUrl";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost, axiosDelete, axiosPatch } from "@/app/helpers/AxiosHelper";
import axios from "axios";
import moment from "moment";

export default {
  mixins: [FormMixin],
  props: {
    depositId: String,
  },
  filters: {
    dateFormat: function (value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data() {
    return {
      preloader: true,
      hide: false,
      disabled: true,
      showAdditional: false,
      titlePayment: "DATOS PARA EL PAGO DE ",
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      cardPayment: null,
      inputs: {},
      files: [],
      tmp: {},
      delayTimer: null,
      confirm: [
        {
          id: 0,
          value: "RECHAZADO",
        },
        {
          id: 1,
          value: "APROBADO",
        },
      ],
      deleteModal: false,
      countryLists: [],
      countryList: [{ id: "", value: "Seleccione País" }],
      provinceLists: [],
      provinceList: [{ id: "", value: "Seleccione Provincia" }],
      cantonLists: [],
      cantonList: [{ id: "", value: "Seleccione Canton" }],
    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    // this.selectedUrl = `${actions.TREASURY}/${this.depositId}`;
    this.loadForm();
    //this.getInfo();
  },
  methods: {
    returnPage() {
      window.location.href = `/treasury/income`;
    },

    openSendModal() {
      if (this.files.length > 0) {
        this.deleteConfirmationModalActive = true;
      } else {
        this.$toastr.e("Se debe subir por lo menos un archivo");
      }
    },

    sendInvoices() {
      let url = `${actions.TREASURY}/sendInvoice?deposit_id=${this.depositId}`;
      this.deleteLoader = true;
      axiosPost(url)
        .then((res) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancel();
          if (res.data.status === true) {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancel() {
      this.deleteConfirmationModalActive = false;
    },

    // Para agregar facturas

    addFile() {
      this.files.push({
        record_id: this.inputs.id,
        filename: null,
        file: null,
      });
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    confirmed() {
      const url = `${actions.TREASURY}/destroyInvoices?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          this.files = res.data.data;
        })
        .catch(({ error }) => {});
    },

    removeRowFile(j) {
      this.files = this.files.filter((value, index) => index != j);
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.files[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.files[j], "file", null);
        this.$set(this.files[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }

      if (!tmp.filename)
        this.$set(this.files[j], "filename", e.target.files[0].name);

      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.files[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `${actions.TREASURY}/storeInvoices`;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.files[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          this.files = res.data.data.invoices;
        })
        .catch(({ error }) => {});
    },
    // End facturas

    beforeSubmit() {
      this.preloader = true;
    },
    // submit() {
    //   const tmp = { ...this.inputs };
    //   if (tmp.is_approved) {
    //     tmp.is_approved = 2;
    //   } else {
    //     tmp.is_approved = 0;
    //   }
    //   const d = tmp.date;
    //   if (tmp.date) {
    //     tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
    //   }
    //   this.save(tmp);
    // },
    afterSuccess(res) {
      this.preloader = true;
      if (res.status == 200) {
        this.returnPage();
      }
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    loadForm() {
      if (this.depositId) {
        let url = `${actions.TREASURY}/${this.depositId}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.getCardTransaction(response.data.eval_test_id);
              this.disabled = true;
              if (response.data.is_approved === 3) {
                this.hide = true;
              }
              this.hide = true;
              this.inputs = response.data;
              this.files = response.data.invoices;
              this.inputs.is_agreement = response.data.is_agreement;
              if (this.inputs.type === "S") {
                this.titlePayment =
                  this.titlePayment + "SOLICITUD DE ACREDITACION";
              } else {
                this.titlePayment = this.titlePayment + "PROFORMA DE SERVICIOS";
              }
              this.inputs.bank = response.data.bank
                ? response.data.bank.name +
                  " - " +
                  response.data.bank.account_number
                : "N/A";
              this.inputs.amount = response.data.amount
                ? response.data.amount + " USD"
                : "N/A";
              this.inputs.transactiontype = response.data.transactiontype
                ? response.data.transactiontype.name
                : "N/A";
              this.inputs.oec =
                response.data.accreditation_application.organization.name;
              this.inputs.taxid =
                response.data.accreditation_application.organization.taxid;
              this.inputs.delegate_name =
                response.data.accreditation_application.delegate_name;
              this.inputs.delegate_position =
                response.data.accreditation_application.delegate_position;
              this.inputs.delegate_email =
                response.data.accreditation_application.delegate_email;
              this.inputs.delegate_phone =
                response.data.accreditation_application.delegate_phone;
              this.inputs.delegate_cell =
                response.data.accreditation_application.delegate_cell;
              this.inputs.is_approved = false;
              var dateString = response.data.date;
              var startDate = new Date(dateString);
              var day = 60 * 60 * 24 * 1000;
              this.inputs.date = new Date(startDate.getTime() + day);
              if (response.data.file) {
                this.inputs.deposit_attach = response.data.file;
              } else {
                this.inputs.deposit_attach = "";
              }
              if (response.data.complementary_documents_deposits) {
                this.inputs.additional_attach = this.inputs.complementary_documents_deposits.full_url;
                this.showAdditional = true;
              } else {
                this.inputs.additional_attach = "";
              }

              if (response.data.accreditation_application.request_signed) {
                this.inputs.request_file =
                  response.data.accreditation_application.request_signed;
              } else {
                this.inputs.request_file = null;
              }

              if (response.data.eval_test.proforma) {
                this.inputs.proforma =
                  response.data.eval_test.proforma;
              } else {
                this.inputs.proforma = null;
              }

              if (response.data.eval_test.external_personal_payment_invoices) {
                this.inputs.external_personal_payment_invoices =
                  response.data.eval_test.external_personal_payment_invoices;
              } else {
                this.inputs.external_personal_payment_invoices = null;
              }

              if (response.data.eval_test.external_personal_payment_vouchers) {
                this.inputs.external_personal_payment_vouchers =
                  response.data.eval_test.external_personal_payment_vouchers;
              } else {
                this.inputs.external_personal_payment_vouchers = null;
              }
              this.getInfo();
            }
          })
          .catch(({ error }) => {})
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    getInfo() {
      let url = `${actions.COMMON_POLITICAL_DIVISION}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.countryLists = response.data.countries;
            this.countryList = [
              ...this.countryLists.filter((item) => {
                return item;
              }),
            ];

            this.provinceLists = response.data.provinces;
            this.provinceList = [
              ...this.provinceLists.filter((item) => {
                return item;
              }),
            ];
            this.cantonLists = response.data.cantons;
            this.cantonList = [
              ...this.cantonLists.filter((item) => {
                return item;
              }),
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getCardTransaction(evalTestId){
      const url = `/treasury/transactions/${evalTestId}`;
      axios.get(url)
      .then(response => {
          if(response.data.status){
              this.cardPayment = response.data.data;
          }
      });
    },
    formatDateLocal(date){
      moment.locale('es');
      return moment(date).format('LL')
    }
  },
};
</script>